/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-card-title-error[_ngcontent-%COMP%]{background:#b30c1c;padding:10px 20px;color:#fff}h2.mat-title.nsc-margin-bottom[_ngcontent-%COMP%]{margin-bottom:-5px}"];
export { styles as styles };
